import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, first } from 'rxjs/operators';
import { UserService } from '../../core/user/user.service';
import { Me } from '../types/me.types';

@Injectable({
    providedIn: 'root',
})
export class QrcodeGuard implements CanActivate {
    constructor(private _userService: UserService, private _router: Router) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> {
        // Estrai i ruoli consentiti dai dati del route
        const allowedRoles = ['amministratore', 'tecnico', 'dipendente', 'magazzino'];


        return this._userService.currentUser$.pipe(
            map((currentUser: Me) => {

                const hasRequiredRole = currentUser.roles.some(role => allowedRoles.includes(role.name));

                if (hasRequiredRole) {
                    return true; // Permetti l'accesso
                } else {
                    return this._router.createUrlTree(['/']);
                }
            }),
            first() // Completa dopo il primo valore
        );
    }
}
